import {IssueTypeToken} from '@github-ui/issue-type-token'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'

import type {IssueSecondaryIssueTypeNode, IssueSecondaryRepositoryNode} from './header-issue-type-query-types'
import styles from './HeaderIssueType.module.css'

// RELAY-CLEANUP(HeaderMetadata, StickyHeaderChips): widens nullable fields so the still-Relay
// parents' data is assignable. Remove when HeaderMetadata and StickyHeaderChips leave Relay.
export type HeaderIssueTypeFragment = RelayCompat<{
  readonly repository: Pick<IssueSecondaryRepositoryNode, 'nameWithOwner'>
  readonly issueType: Pick<IssueSecondaryIssueTypeNode, 'name' | 'color'> | null
}>

export type HeaderIssueTypeProps = {
  data: HeaderIssueTypeFragment
}

export function HeaderIssueType({data: {issueType, repository}}: HeaderIssueTypeProps) {
  if (!issueType) return null

  const getTooltipText = (isTextTruncated: boolean) => {
    return isTextTruncated ? issueType.name : undefined
  }

  return (
    <IssueTypeToken
      name={issueType.name}
      color={issueType.color}
      href={`/${repository.nameWithOwner}/issues?q=type:"${issueType.name}"`}
      getTooltipText={getTooltipText}
      size="large"
      className={styles.IssueTypeToken}
    />
  )
}

export const SmallHeaderIssueType = ({data: {issueType}}: HeaderIssueTypeProps) => {
  if (!issueType) return null

  return <div className={styles.smallToken}>{issueType.name}</div>
}
